import { useSyncExternalStore } from "react";

/** Whether a CSS media query matches now, following it as the window changes. */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const list = window.matchMedia?.(query);
      list?.addEventListener("change", onChange);
      return () => list?.removeEventListener("change", onChange);
    },
    () => window.matchMedia?.(query).matches ?? false,
    () => false,
  );
}

/** Phone width: narrower than 768 px (guide 3.6). */
export function usePhoneWidth(): boolean {
  return useMediaQuery("(max-width: 767.98px)");
}
